import Vue from 'vue'

const STORAGE_KEY = 'yqzx_points_balance'
const RECORDS_KEY = 'yqzx_points_records'
const DEFAULT_BALANCE = 100

export const pointsStore = Vue.observable({
  balance: 0,
  records: []
})

function loadBalance() {
  const raw = localStorage.getItem(STORAGE_KEY)
  if (raw === null) {
    localStorage.setItem(STORAGE_KEY, String(DEFAULT_BALANCE))
    return DEFAULT_BALANCE
  }
  return Number(raw) || 0
}

function loadRecords() {
  try {
    const raw = localStorage.getItem(RECORDS_KEY)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

function saveBalance(value) {
  localStorage.setItem(STORAGE_KEY, String(value))
  pointsStore.balance = value
}

function saveRecords(records) {
  localStorage.setItem(RECORDS_KEY, JSON.stringify(records))
  pointsStore.records = records
}

function addRecord(record) {
  const records = [record, ...loadRecords()].slice(0, 50)
  saveRecords(records)
}

export function initPoints() {
  pointsStore.balance = loadBalance()
  pointsStore.records = loadRecords()
}

export function getBalance() {
  return pointsStore.balance
}

export function rechargePoints(amount, meta = {}) {
  const balance = loadBalance() + amount
  saveBalance(balance)
  addRecord({
    id: `rec-${Date.now()}`,
    type: 'recharge',
    amount,
    balance,
    title: meta.title || '积分充值',
    time: formatTime(new Date())
  })
  return balance
}

export function consumePoints(amount, meta = {}) {
  const current = loadBalance()
  if (current < amount) {
    return { ok: false, balance: current }
  }
  const balance = current - amount
  saveBalance(balance)
  addRecord({
    id: `rec-${Date.now()}`,
    type: 'consume',
    amount: -amount,
    balance,
    title: meta.title || '积分消费',
    time: formatTime(new Date())
  })
  return { ok: true, balance }
}

export function formatTime(date) {
  const pad = n => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

/** 视频分析单次消耗积分 */
export const ANALYSIS_COST = 50

export const RECHARGE_PACKAGES = [
  { id: 'pkg-100', points: 100, price: 10, bonus: 0, label: '体验包' },
  { id: 'pkg-500', points: 500, price: 45, bonus: 50, label: '热门' },
  { id: 'pkg-1000', points: 1000, price: 88, bonus: 120, label: '超值' },
  { id: 'pkg-2000', points: 2000, price: 168, bonus: 300, label: '专业版' }
]
